<ul *ngIf="files && files.length">
    <li *ngFor="let file of files">
        {{ file.name }} ({{ file.size | number }} bytes)
    </li>
</ul>
<div class="text-start align-middle text-xl p-2 h-10 pl-4 leading-5" *ngIf="externState?.slug" [ngClass]="'bg-'+getSlugText(externState?.slug || '')"> {{ 'EXTERN.' + (externState ? getSlugText(externState.slug) : "") | uppercase | translate}} </div>
<div *ngIf="hasDecision" class="w-full p-4 h-28 flex flex-col justify-center items-end border-dashed border-b-2 gap-1">
    <div class="flex flex-col text-right justify-end flex-wrap">
        <div class="rejected gap-1 text-base font-bold flex text-center" *ngIf="main_approver?.status === MEMBER_STATUS.REJECT || some_preempt_rejected"><mat-icon>cancel</mat-icon> <span>{{ (some_preempt_rejected ? 'VIEW.DOCUMENT_APPROVER_REJECT' : current_member?.hasApproDocument? 'VIEW.DOCUMENT_YOU_REJECT' : 'VIEW.DOCUMENT_APPROVER_REJECT') | translate }} </span></div>
        <div class="approved gap-1 text-base font-bold flex text-center" *ngIf="main_approver?.status === MEMBER_STATUS.ACCEPT"><mat-icon>verified</mat-icon> <span>{{ (current_member?.hasApproDocument? 'VIEW.DOCUMENT_YOU_ACCEPT' : 'VIEW.DOCUMENT_APPROVER_ACCEPT') | translate }}</span></div>
        <!-- <div class="pending-delivery" *ngIf="approved && !intern_delivered"><strong>{{ 'VIEW.PENDING_DELIVERY' | translate }}</strong></div> -->
    </div>
    <div *ngIf="!s_proofreadings.pending.current" class="flex justify-end items-center gap-2 leading-4">
        <ng-container *ngIf="this.isClient() && canApprove; else stateMachine">
            <ng-container *ngIf="isCurrentOrder">
                <button mat-flat-button (click)="onReject()" [disabled]="project_archived" [ngClass]="'bg-'+EXTERN_STATE_NAME.REJECTED" [matTooltip]="getTooltip() | translate">
                    <span class="flex items-center gap-1">
                        <mat-icon>close</mat-icon> <span>{{'EXTERN.BTN.REJECTED' | translate}} </span>
                    </span>
                </button>
                <button mat-flat-button (click)="onApprove()" [disabled]="project_archived" [ngClass]="'bg-'+EXTERN_STATE_NAME.APPROVED" [matTooltip]="getTooltip() | translate">
                    <span class="flex items-center gap-1">
                        <mat-icon>check</mat-icon> <span>{{'EXTERN.BTN.APPROVED' | translate}} </span>
                    </span>
                </button>
            </ng-container>
        </ng-container>
        <ng-template #stateMachine>
            <ng-container *ngFor="let next of nextStates">
                <button [ngClass]="'bg-'+getSlugText(next)" mat-flat-button *ngIf="nextCondition(next)" [disabled]="project_archived" (click)="onNextState(next)" [matTooltip]="getTooltip() | translate">
                    <span class="flex items-center gap-1">
                        <mat-icon [ngClass]="'icon-'+getSlugText(next)"></mat-icon>
                        <span>{{'EXTERN.BTN.' + getSlugText(next) | uppercase | translate}}</span>
                    </span>
                </button>
            </ng-container>
        </ng-template>
        <ng-container *ngIf="isAdmin()">
            <button class="bg-control-failed" mat-flat-button type="button" (click)="resetProdAdmin()">
                <span class="flex items-center gap-1">
                    <mat-icon [ngClass]="'icon-control-failed'"></mat-icon>
                    <span> {{ 'RESET_PROD.BTN' | translate }} </span>
                </span>
            </button>
        </ng-container>
    </div>
    <ngx-skeleton-loader *ngIf="s_proofreadings.pending.current" class="w-[40%] flex gap-2" count="2" [theme]="{ 'height':'40px' }"></ngx-skeleton-loader>
</div>
<!-- <ng-container *ngIf="!isCurrentOrder && canCustomerInfoApprove" class="">
    <mat-icon>hourglass_empty</mat-icon>
    <span>{{ 'EXTERN.WAIT_YOUR_TURN' | translate }}{{ proofreading?.current_order }}</span> 
</ng-container> -->